import React, { Suspense, lazy } from 'react';
import { Routes, Route, HashRouter } from 'react-router-dom';
import './index.css';
import '@questlabs/react-sdk/dist/style.css';

// Performance: Code-splitting pages to reduce initial bundle size
const Home = lazy(() => import('./pages/Home'));
const Videos = lazy(() => import('./pages/Videos'));
const Chatbots = lazy(() => import('./pages/Chatbots'));
const News = lazy(() => import('./pages/News'));
const Simulator = lazy(() => import('./pages/Simulator'));
const ArticleAIWork = lazy(() => import('./pages/ArticleAIWork'));

// Simple loading placeholder
const PageLoader = () => (
  <div className="min-h-screen bg-dark-900 flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-cyan-500/20 border-t-cyan-500 rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <HashRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/chatbots" element={<Chatbots />} />
          <Route path="/news" element={<News />} />
          <Route path="/simulator" element={<Simulator />} />
          <Route path="/ai-work-great-resorting" element={<ArticleAIWork />} />
        </Routes>
      </Suspense>
    </HashRouter>
  );
}

export default App;